document.addEventListener('DOMContentLoaded', function() {
  if (!window.customerId) return;
  fetch('https://maestra-auth.vercel.app/api/maestra-check-customer', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ customerId: window.customerId })
  })
  .then(r => r.json())
  .then(data => {
    let points = 0;
    let tier = 'JOLYNSIDER';
    if (data.getData && data.getData.balances && data.getData.balances.length > 0) {
      points = parseInt(data.getData.balances[0].available, 10) || 0;
    }
    if (data.getData && data.getData.customerSegmentations) {
      const segments = data.getData.customerSegmentations.map(seg => seg.segment && seg.segment.name);
      if (segments.includes('Maestra JOLYNPIAN')) {
        tier = 'JOLYNPIAN';
      } else if (segments.includes('Maestra JOLYNFLUENCER')) {
        tier = 'JOLYNFLUENCER';
      } else if (segments.includes('Maestra JOLYNSIDER')) {
        tier = 'JOLYNSIDER';
      }
    }
    window.loyaltyPoints = points;
    window.loyaltyTier = tier;
    document.dispatchEvent(new CustomEvent('loyaltyDataLoaded', { detail: { points, tier } }));
    console.log('[Loyalty] Loaded:', { points, tier });
  })
  .catch(err => {
    window.loyaltyPoints = null;
    window.loyaltyTier = null;
    document.dispatchEvent(new CustomEvent('loyaltyDataLoaded', { detail: { points: null, tier: null, error: err } }));
    console.error('[Loyalty] Error loading data:', err);
  });
}); 